<h1 *ngIf="showHeader" class="show_header">
	Protege tus cuentas con una NUEVA clave más segura. +info
	<a class="link" href="https://cp.com.pe/pacifico/clave-segura/" target="_blank"> aquí</a>
</h1>
<br />
<h1>Cambio de Clave</h1>
<div class="tab-slider--container">
	<div class="usuario_contrasena" *ngIf="!showSuccess">
		<form #myform="ngForm">
			<div class="form_row clearfix">
				<div class="form_cell">
					<label>Nueva Clave:</label>
					<span class="user_dni_codigo">
						<input
							type="password"
							[(ngModel)]="password"
							[ngClass]="{ val_error: validateInputPassword() }"
							name="password"
							class="form_element"
							placeholder="Ingrese su nueva clave"
							maxlength="10"
							minlength="8"
							required
							alphaSpecialPassword
						/>
						<app-valid-message-form
							*ngIf="validateInputPassword()"
							[message]="messagePasswordInput"
							type="error"
						></app-valid-message-form>
					</span>
					<div class="condiciones_clave">
						<span
							>Clave debe contener: Una letra, un número y uno de estos caracteres especiales (& &#35; &#46; , ;).
							Longitud entre 8 a 10 caracteres.</span
						>
					</div>
				</div>
			</div>
			<div class="form_row clearfix">
				<div class="form_cell">
					<label>Confirmar Nueva Clave:</label>
					<span class="user_contrasena">
						<input
							type="password"
							[(ngModel)]="repeatPassword"
							[ngClass]="{ val_error: validateInputPasswordRepeat() }"
							name="repeatPassword"
							class="form_element"
							placeholder="Reingrese su nueva clave"
							maxlength="10"
							minlength="8"
							required
							alphaSpecialPassword
						/>
						<app-valid-message-form
							*ngIf="validateInputPasswordRepeat()"
							[message]="messageErrorPassword"
							type="error"
						></app-valid-message-form>
					</span>

					<span>Debe coincidir con nueva clave</span>
				</div>
			</div>

			<div class="center_content">
				<button
					class="boton_ingresar enviar_clave"
					[disabled]="myform?.invalid && this.myform?.touched && !validatePassword()"
					(click)="clickSave()"
				>
					Guardar
				</button>
			</div>
		</form>
	</div>
	<div class="revisar_correo" *ngIf="showSuccess">
		<app-alert title="¡Felicidades!" message="La clave fue modificada correctamente." type="succes"></app-alert>

		<div class="center_content">
			<a routerLinkActive="router-link-active" class="boton_ingresar button" (click)="goToLogin()"
				>INGRESA A TU CUENTA</a
			>
		</div>
	</div>
</div>
